export const theme = {
  black: "#000000",
  white: "#ffffff",
  whiteLight: "#f3f3f3",
  whiteShade: "#f8f8f8",
  whitePrimary: "#f9f9f9",
  darkBlue: "#14183e",
  blackLight: "#3b3b3c",
  blacksmoke: "#414143",
  gulfBlue: "#37415c",
  graySlate: " ",
  grayLight: " #cfcfcf",
  grayPayne: "#474748",
  grayPayneLight: "#434345",
  pinkLight: "#eee0e4",
  pinkAntiquePetal: "#e9e5e5",
  grayGrandient: "radial-gradient(#fff, #e6e6e6)",
  blackGrandient: "radial-gradient(#767678, #3b3b3c)",
  whiteLightGradient: "linear-gradient(180deg, #f8f8f8, #fff)",
  whiteLightGrandient: "linear-gradient(to bottom, #f8f8f8, #fff)",
  pinkGraindient: "linear-gradient(180deg,#f8e9ed,#fbfbfb)",
  pinkGraindentLight: "linear-gradient(to bottom, #f8e9ed, #fbfbfb) ",
};
